module.exports = __webpack_public_path__ + "img/31.fcee5cb0.png";